import React, { useContext } from 'react'
import Button from '@mui/material/Button'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Paper, Typography, Slide } from '@mui/material'
import { CookieConsentContext } from '../../../contexts/CookieConsentContext'
import CookieConsentModal from '../../Modais/CookieConsentModal/CookieConsentModal'

const DrawerCookieConsent = () => {
  const { toggleModal, toggleDrawer, isDrawerOpen, acceptCookies, declineCookies } =
    useContext(CookieConsentContext)

  const onRefuse = () => {
    declineCookies()
    toggleDrawer()
  }

  const onAccept = () => {
    acceptCookies()
    toggleDrawer()
  }

  return (
    <>
      <CookieConsentModal />
      <Slide direction='up' in={isDrawerOpen} timeout={{ enter: 300, exit: 300 }}>
        <Paper
          elevation={4}
          sx={{
            zIndex: 2,
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            m: { xs: 2, md: 3 },
            p: 2,
            width: { sm: 600, md: 700 },
          }}
        >
          <Typography sx={{ fontSize: { md: '18px' }, pb: 1.5 }}>
            Utilizamos cookies para melhorar sua experiência de navegação, personalizar conteúdo e
            anúncios, e analisar o tráfego do nosso site.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button variant='text' onClick={toggleModal}>
              <Typography>Gerenciar cookies</Typography>
              <ChevronRightIcon fontSize='small' />
            </Button>
            <Button variant='outlined' onClick={onRefuse}>
              Rejeitar
            </Button>
            <Button variant='contained' onClick={onAccept}>
              Aceitar
            </Button>
          </Box>
        </Paper>
      </Slide>
    </>
  )
}

export default DrawerCookieConsent
